module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "c-header u-block u-fit-w"
  }, [_c('div', {
    staticClass: "c-main-menu-matches u-relative u-fit-w u-bg--black u-flex--x u-flex--align-items--center js-header-matches u-hide@md"
  }, [_c('div', {
    staticClass: "u-absolute u-pos-bl u-fit-w u-height-2"
  }), _vm._v(" "), (_vm.contentGlobal.headerMatches.length > 0) ? _c('h1', {
    staticClass: "u-marg-l-xl u-marg-r-xxl"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.$root.getPageURLFromID('home')
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.contentGlobal.mainLogo,
      "alt": "Gfinity - Elite Series",
      "width": "196",
      "height": "54"
    }
  })])], 1) : _c('h1', {
    staticClass: "u-block u-fit-w u-align-center u-marg-t-auto u-marg-b-xs"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.$root.getPageURLFromID('home')
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.contentGlobal.mainLogo,
      "alt": "Gfinity - Elite Series",
      "width": "196",
      "height": "54"
    }
  })])], 1), _vm._v(" "), (_vm.contentGlobal.headerMatches.length > 0) ? [_c('div', {
    staticClass: "u-flex__item--auto"
  }), _vm._v(" "), _c('div', {
    staticClass: "u-flex--x u-flex--center"
  }, _vm._l((_vm.contentGlobal.headerMatches), function(match, index) {
    return _c('app-menu-match', {
      key: match.id,
      staticClass: "t-text--md",
      class: {
        'u-hide': index >= _vm.matchDisplay, 'is-last': index + 1 === _vm.matchDisplay || index + 1 >= _vm.contentGlobal.headerMatches.length
      },
      attrs: {
        "display-game": _vm.matchesGameId < 1,
        "match": match,
        "content-global": _vm.contentGlobal,
        "hideScore": _vm.hideScore
      }
    })
  })), _vm._v(" "), (_vm.matchesGameId > 0) ? _c('div', {
    staticClass: "t-text--md u-align-center u-marg-r-xxl"
  }, [(_vm.matchesGameId === 1) ? _c('img', {
    attrs: {
      "src": require("../../../assets/games/counter-strike-global-offensive-w100.png"),
      "alt": "CS:GO"
    }
  }) : (_vm.matchesGameId === 2) ? _c('img', {
    attrs: {
      "src": require("../../../assets/games/street-fighter-v-w100.png"),
      "alt": "Street Fighter V"
    }
  }) : (_vm.matchesGameId === 3) ? _c('img', {
    attrs: {
      "src": require("../../../assets/games/rocket-league-w100.png"),
      "alt": "Rocket League"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-flex__item--auto"
  })] : _vm._e(), _vm._v(" "), (_vm.contentGlobal.headerMatches.length > 0) ? _c('div', {
    staticClass: "u-marg-r-lg u-vacuum u-cursor-pointer u-align-right",
    on: {
      "click": function($event) {
        _vm.hideScore = !_vm.hideScore
      }
    }
  }, [_c('div', {
    staticClass: "t-text--xs t-text--bold u-uppercase u-relative u-color--white u-align-center u-block u-align-right u-valign-middle u-marg-b-xxxs u-align-center"
  }, [_c('span', {
    staticClass: "c-hide-text u-absolute u-pos-tl u-block u-fit-w u-align-center",
    class: {
      'is-visible': !_vm.hideScore
    },
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.taxonomies.matches.hideMatches.replace(' ', '&nbsp;'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-hide-text u-relative u-inline-block",
    class: {
      'is-visible': _vm.hideScore
    },
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.taxonomies.matches.showMatches.replace(' ', '&nbsp;'))
    }
  })]), _vm._v(" "), _c('app-btn-toggle', {
    staticClass: "u-inline-block u-valign-middle u-marg-r-xxs",
    attrs: {
      "active": _vm.hideScore
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('app-menu', {
    attrs: {
      "content-global": _vm.contentGlobal,
      "content-page": _vm.contentPage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35f969b2"}!./src/scripts/components/app-header/template.html
// module id = 903
// module chunks = 0